import { forwardRef } from 'react';
import classNames from 'classnames';
import { IImage, Video } from '@sapientpro/sapientpro-data-models';
import Link from 'next/link';
import styles from './RevealingCaseSection.module.scss';
import Img from '../Img';
import Button, { ButtonVariants } from '../Button';
import VideoComponent from '../Video/Video';
import { pathTo } from '../../paths';

interface IPointMediaProps {
  isClosedCase: boolean;
  hasCase: boolean;
  caseSlug: string;
  media: IImage | Video | null;
  isVideo: boolean;
  pointsImage?: IImage;
  mobile?: boolean;
}

const PointMedia = forwardRef<HTMLDivElement, IPointMediaProps>(({
  isClosedCase,
  hasCase,
  caseSlug,
  media,
  isVideo,
  pointsImage,
  mobile,
}, ref) => {
  const isLink = hasCase && !isClosedCase;
  const CaseElement = isLink ? Link : 'div';

  return (
    <div
      ref={ref}
      className={classNames(styles.revealingCaseSection__contentCase, {
        [styles.revealingCaseSection__contentCase_underNDA]: isClosedCase,
        [styles.mobile]: mobile,
      })}
    >
      <CaseElement
        className={styles.revealingCaseSection__contentCaseLink}
        {...(isLink ? { href: pathTo('case', { slug: caseSlug }) } : { href: '/' })}
      >
        {!isVideo ? (
          (!!media?.url && (
            <Img
              src={media?.url || ''}
              alt={media?.alternativeText ?? 'Item image'}
              className={styles.revealingCaseSection__contentCaseLinkImage}
              withPreloader
            />
          ))
        )
          : (
            <VideoComponent
              video={{
                title: '',
                clip: {
                  id: media?.id || 0,
                  url: media?.url || '',
                  alternativeText: media?.alternativeText ?? 'Item video',
                  ext: media?.ext || 'mp4',
                  caption: '',
                },
                loop: true,
                autoPlay: true,
                preview: {
                  url: pointsImage?.url || '',
                  alternativeText: pointsImage?.alternativeText ?? 'Item preview image',
                },
              }}
              videoType='custom'
              view='default'
              activeIndex={0}
              videoWrapperClassName={styles.revealingCaseSection__contentCaseLinkVideoWrapper}
              videoClassName={styles.revealingCaseSection__contentCaseLinkVideo}
              videoPreviewClassName={styles.revealingCaseSection__contentCaseLinkVideoPreview}
            />
          )}
        {hasCase && <div className={classNames(styles.revealingCaseSection__contentCaseLinkTag, 'tag')}>Case</div>}
      </CaseElement>
      <div className={styles.revealingCaseSection__contentCaseNDAOverlay}>
        <h4 className={classNames(styles.revealingCaseSection__contentCaseNDAOverlayTitle)}>This Case Study is Under NDA</h4>
        <p className={styles.revealingCaseSection__contentCaseNDAOverlayDescription}>
          {'Interested in the specifics? \n Book an individual consultation with our experts to discuss your project.'}
        </p>
        <Button
          link='#contact-form'
          variant={ButtonVariants.OUTLINED}
          className={styles.revealingCaseSection__contentCaseNDAOverlayButton}
        >
          Book a call
        </Button>
      </div>
    </div>
  );
});

export default PointMedia;
